import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './styles.css';
import '@fontsource/rubik';
import '@fontsource/rubik/300.css';
import '@fontsource/rubik/400.css';
import '@fontsource/rubik/500.css';
import '@fontsource/rubik/700.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { SearchResult } from './components/SearchResult';
import { HomeContainer } from './containers/HomeContainer';
// This is where your application content can be mounted
var Root = function () {
    return (React.createElement(Router, null,
        React.createElement(Switch, null,
            React.createElement(Route, { path: '/', exact: true, component: HomeContainer }),
            React.createElement(Route, { path: '/:id', component: SearchResult }))));
};
ReactDOM.render(React.createElement(Root, null), document.getElementById('root'));
